/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ContactsButton.vue?vue&type=template&id=bedf1cd6"
import script from "./ContactsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactsButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContactsButton.vue?vue&type=style&index=0&id=bedf1cd6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports